<div id="layout-wrapper">
  <app-progress-bar></app-progress-bar>
  <!-- Top Bar -->
  <app-topbar (mobileMenuButtonClicked)="onToggleMobileMenu()"></app-topbar>
  <!-- Side Bar -->
  <app-sidebar *ngIf="isVerticalLayoutRequested()"></app-sidebar>
  <app-horizontal-topbar *ngIf="isHorizontalLayoutRequested()"></app-horizontal-topbar>
  <div class="main-content">
    <div class="page-content">
      <div class="container-fluid">
        <!-- Main Content -->
        <router-outlet></router-outlet>
      </div>
    </div>
    <!-- Footer -->
    <app-footer></app-footer>
  </div>
  <!-- Balão flutuante do chat (esconde-se na própria página /chat e sem acesso ao chat) -->
  <app-chat-launcher></app-chat-launcher>
</div>
<!-- Right Side Bar -->
<!-- <app-rightsidebar (settingsButtonClicked)="onSettingsButtonClicked()"></app-rightsidebar> -->